module.exports = __webpack_public_path__ + "static/SOliverxTrampolin_clip-e7d70c941a66a4b626f2d6f3208cd6b0.mp4";